import { Product } from '~/models/product/Product'
import { IStoredProduct } from '~/store/documents/favorites/local-store/models/stored-favorite/stored-product/IStoredProduct'

export class StoredProduct {
  public static toProduct({ ref, name, thumb }: IStoredProduct) {
    return new Product(ref, name, thumb)
  }
}
